import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { SendCommandComponent } from '../send-command/send-command.component';

@Component({
  selector: 'app-send-command-dialog',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    SendCommandComponent
  ],
  templateUrl: './send-command-dialog.component.html',
  styleUrl: './send-command-dialog.component.scss'
})
export class SendCommandDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { elementId?: string, submitted?: () => void },
    private _parentDialogRef: MatDialogRef<SendCommandDialogComponent>
  ) {
  }

  onSubmit(){
    this.data.submitted?.();
    this.closeDialog();
  }
  closeDialog() {
    this._parentDialogRef.close();
  }
}
